import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Radio, Select, Button, Modal, Input, Form, Spin, Icon } from "antd";
import RegularExpression from '../../../constants/RegularExpression';
import Permissions from '../Affiliates/Permissions';
import { addNewAffiliate, getAffiliates, getUserAllowedAffiliates } from "../../../actions/AffiliateActions";
import configs from "../../../constants/Configs";

const RadioGroup = Radio.Group;
const { Option } = Select;
const { TextArea } = Input;

class AddAffiliate extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            radioButtonValue: 1,
            newAffiliate: {
                name: '',
                email: '',
                notes: '',
                ownerId: null,
                status: null,
                templateId: 1,
                permissions: ["None"],
            },
        };
    }

    handlePermissionsChange = (permissions) => {
        this.setState({
            newAffiliate: {
                ...this.state.newAffiliate,
                permissions
            }
        });
    };

    showModal = () => {
        this.setState({
            visible: true,
        });
    };

    onNextClick = (form, props, state) => {
        if (this.state.radioButtonValue === 1) {
            //Validate completed data
            form.validateFields((err, values) => {
                if (!err) {
                    this.setState({
                        radioButtonValue: this.state.radioButtonValue + 1,
                        newAffiliate: {
                            ...this.state.newAffiliate,
                            ...values
                        },
                    });
                }
            });
        } else {
            this.setState({
                radioButtonValue: this.state.radioButtonValue + 1,
            });
        }
    };

    onBackClick = () => {
        this.setState({
            radioButtonValue: this.state.radioButtonValue - 1,
        })
    };

    handleCancel = e => {
        this.setState({
            visible: false,
        });
    };

    afterCloseModal = () => {
        this.setState({
            radioButtonValue: 1,
        });
    };

    handleSubmit = (form, props, state) => {
        const { mainPartnerId } = this.props.affiliates;

        //Validate completed data
        form.validateFields((err, values) => {
            if (!err) {
                this.props.dispatch(addNewAffiliate(state.newAffiliate, this.props.intl)).then((status) => {
                    if (status !== "error") {
                        this.setState({
                            visible: false,
                        });
                        this.props.dispatch(getAffiliates(mainPartnerId, this.props.affiliatesData));
                        this.props.dispatch(getUserAllowedAffiliates(state.newAffiliate.ownerId))
                    }
                });
            }
        });
    };

    onSelectAff = (e) => {
        this.setState({
            newAffiliate: {
                ...this.state.newAffiliate,
                templateId: e.target.value,
            },
        });
    };

    render() {
        const { radioButtonValue } = this.state;
        const { getFieldDecorator } = this.props.form;
        const { allowedPartners } = this.props.affUser;
        const builderURL =  configs.CDN_URL;

        const antIcon = <Icon type="loading" className="ta--ant_loader" spin />;

        const allowedPartnersList = allowedPartners && Object.keys(allowedPartners).map((key) =>
            <Option key={allowedPartners[key].PartnerId} value={allowedPartners[key].PartnerId}>{allowedPartners[key].PartnerName}</Option>
        );

        let renderRadioForm = (radioButtonValue) => {
            switch (radioButtonValue) {
                case 1:
                    return (
                        <React.Fragment>
                            <Form.Item label={this.props.intl.messages.name}>
                                {getFieldDecorator('name', {
                                    initialValue: this.state.newAffiliate.name,
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.intl.messages.required_name
                                        },
                                        {
                                            pattern: RegularExpression.ONLY_LETTERS,
                                            message: this.props.intl.messages.name_validation_message
                                        }
                                    ],
                                })(
                                    <Input autoComplete="off" maxLength={50} />
                                )}
                            </Form.Item>
                            <Form.Item label={this.props.intl.messages.email}>
                                {getFieldDecorator('email', {
                                    initialValue: this.state.newAffiliate.email,
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.intl.messages.email_required
                                        },
                                        {
                                            pattern: RegularExpression.EMAIL_VALIDATION,
                                            message: this.props.intl.messages.invalid_mail
                                        }
                                    ],
                                })(
                                    <Input autoComplete="off" maxLength={150} />
                                )}
                            </Form.Item>

                            <Form.Item label={this.props.intl.messages.notes}>
                                {getFieldDecorator('notes', {
                                    initialValue: this.state.newAffiliate.notes
                                })(
                                    <TextArea rows={4} />
                                )}
                            </Form.Item>

                            <Form.Item label={this.props.intl.messages.owner}>
                                {getFieldDecorator('ownerId', {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.intl.messages.required_field
                                        },
                                    ],
                                    initialValue: this.state.newAffiliate.ownerId
                                })(
                                    <Select>
                                        {allowedPartnersList}
                                    </Select>
                                )}
                            </Form.Item>

                            <Form.Item label={this.props.intl.messages.status}>
                                {getFieldDecorator('status', {
                                    rules: [
                                        {
                                            required: true,
                                            message: this.props.intl.messages.required_field
                                        },
                                    ],
                                    initialValue: this.state.newAffiliate.status
                                })(
                                    <Select>
                                        <Option value={1}>{this.props.intl.messages.active}</Option>
                                        <Option value={3}>{this.props.intl.messages.block}</Option>
                                    </Select>
                                )}
                            </Form.Item>
                        </React.Fragment>
                    );
                case 2:
                    return (
                        <Radio.Group className='ta--affiliate-design ta--mb-16'
                            value={this.state.newAffiliate.templateId} onChange={this.onSelectAff}>
                            <Radio className='ta--aff-design_1 fi' value={1}>
                                <a target="_blank"
                                    href={"https://classic" + builderURL}>{this.props.intl.messages.preview}</a>
                            </Radio>
                            <Radio className='ta--aff-design_2 fi' value={2}>
                                <a target="_blank"
                                    href={"https://blues" + builderURL}>{this.props.intl.messages.preview}</a>
                            </Radio>
                            <Radio className='ta--aff-design_3 fi' value={3}>
                                <a target="_blank"
                                    href={"https://rock" + builderURL}>{this.props.intl.messages.preview}</a>
                            </Radio>
                            <Radio className='ta--aff-design_5 fi' value={5}>
                                <a target="_blank"
                                    href={"https://pop" + builderURL}>{this.props.intl.messages.preview}</a>
                            </Radio>
                            <Radio className='ta--aff-design_7 fi' value={7}>
                                <a target="_blank"
                                    href={"https://folk" + builderURL}>{this.props.intl.messages.preview}</a>
                            </Radio>
                        </Radio.Group>
                    );
                case 3:
                    return (
                        <React.Fragment>
                            <Form.Item>
                                {getFieldDecorator('permissions', {})(
                                    <Permissions newAffiliatePermissions={this.state.newAffiliate.permissions}
                                        onPermissionsChange={this.handlePermissionsChange} />
                                )}
                            </Form.Item>
                        </React.Fragment>

                    )
                default:
                    return null;
            }
        }

        let footerContent = (radioButtonValue) => {
            switch (radioButtonValue) {
                case 1:
                    return (
                        <React.Fragment key="banner1footer">
                            <Button onClick={this.handleCancel} key="cancel">{this.props.intl.messages.cancel}</Button>
                            <Button onClick={this.onNextClick.bind(this, this.props.form, this.props, this.state)}
                                key="next" type="primary">{this.props.intl.messages.next}</Button>
                        </React.Fragment>
                    )
                case 2:
                    return (
                        <React.Fragment>
                            <Button key="back" onClick={this.onBackClick}>{this.props.intl.messages.back}</Button>
                            <Button key="add" onClick={this.onNextClick}
                                type="primary">{this.props.intl.messages.next}</Button>
                        </React.Fragment>
                    )
                case 3:
                    return (
                        <React.Fragment>
                            <Button key="back" onClick={this.onBackClick}>{this.props.intl.messages.back}</Button>
                            <Button key="add"
                                onClick={this.handleSubmit.bind(this, this.props.form, this.props, this.state)}
                                type="primary">{this.props.intl.messages.add}</Button>
                        </React.Fragment>
                    )
                default:
                    return null;
            }
        }

        let titleContent = (radioButtonValue) => {
            switch (radioButtonValue) {
                case 1:
                    return this.props.intl.messages.add_new;
                case 2:
                    return this.props.intl.messages.preview;
                case 3:
                    return this.props.intl.messages.permissions;
                default:
                    return null;
            }
        }

        return (
            <div>
                <Button type="primary" onClick={this.showModal}>
                    {this.props.intl.messages.add_new}
                </Button>

                <Modal
                    visible={this.state.visible}
                    onCancel={this.handleCancel}
                    afterClose={this.afterCloseModal}
                    footer={footerContent(radioButtonValue)}
                >
                    <Spin indicator={antIcon} spinning={this.props.affiliates.inProcess}>
                        <RadioGroup value={radioButtonValue} className='ta--flex ta--align-center ta--justify-center rtl--row-reverse'>
                            <Radio value={1}></Radio>
                            <Radio value={2}></Radio>
                            <Radio value={3}></Radio>
                        </RadioGroup>
                        <div className="ta--add_aff_modal_header rtl--text-right">
                            <h3>{titleContent(radioButtonValue)}</h3>
                        </div>
                        <Form layout="vertical">
                            {renderRadioForm(radioButtonValue)}
                        </Form>
                    </Spin>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        affiliates: state.affiliates,
        affUser: state.affUser,
        user: state.user
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return ({

        dispatch

    })
}

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(Form.create()(AddAffiliate)));


// WEBPACK FOOTER //
// ./src/routes/mainAffilate/Affiliates/AddAffiliate.js